import * as React from 'react';

import { observer } from 'mobx-react';
import styled from 'styled-components';

import { InfoIcon } from '@estee/elc-icons';

const MessageWrapper = styled.div`
    display: flex;
    align-items: center;
`;

export interface IMessageProps {
    message?: string;
    children?: React.ReactNode;
    className?: string;
}

export const Message = observer(({ message, children: icon, className }: IMessageProps) => {
    return message ? (
        <MessageWrapper className={className}>
            {icon}
            <span> {message}</span>
        </MessageWrapper>
    ) : null;
});

export const ErrorMessage = observer(({ message, className }: Omit<IMessageProps, 'children'>) => (
    <Message message={message} className={className}>
        <InfoIcon className={'elc-info-icon'} />
    </Message>
));
